import { DatePicker, Tooltip, Select, message } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination";
import { Link } from "react-router-dom";
import HolidayService from "../../../Services/HolidayService";
import DataParser from "../../../utlits/Dataparser";
import StatusBadge from "../../Reuseable/StatusBadge";
import SocketService from "../../../Services/SocketService";
import DepartmentServices from "../../../Services/DepartmentServices";
import UserService from "../../../Services/UserService";
import UserMultiSelect from "../../Reuseable/UserMultiSelect";
import TableSkeleton from "../../Reuseable/TableSkeleton";
import "react-loading-skeleton/dist/skeleton.css";

message.config({ zIndex: 1000000001 });

const { Option } = Select;

const Holidays = () => {
  const [holidaysList, setHolidaysList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [editId, setEditId] = useState(null);
  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [type, setType] = useState("Full Day");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [userPermissions, setuserPermissions] = useState([]);
  const [deleteModal, setDeleteModal] = useState({ visible: false, item: null });

  const [editName, setEditName] = useState("");
  const [editDate, setEditDate] = useState(null);
  const [editEndDate, setEditEndDate] = useState(null);
  const [editType, setEditType] = useState("");

  const [departmentsList, setDepartmentsList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [editSelectedDepartments, setEditSelectedDepartments] = useState([]);
  const [editSelectedUsers, setEditSelectedUsers] = useState([]);

  const compid = DataParser.CompanyId();
  const datee = DataParser.getDateinFormat();
  const dateee = DataParser.getDateinFormat();

  useEffect(() => {
    setDate(datee);
    setEndDate(dateee);
    getAllHolidays();
    getCompanyDepartments();
    getCompanyUsers();
    const upermission = DataParser.CompanyUserPermissions();
    setuserPermissions(upermission);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (pageSize > 15) setCurrentPage(1);
  }, [pageSize]);

  useEffect(() => {
    SocketService.connect();
    const handleHolidayUpdate = (data) => {
      if (data.company_id === compid) getAllHolidays();
    };
    SocketService.on("holiday_update", handleHolidayUpdate);
    return () => { SocketService.off("holiday_update", handleHolidayUpdate); };
  }, [compid]);

  const getCompanyDepartments = () => {
    DepartmentServices.getCompanyDepartment(compid).then((res) => {
      const Data = res.data.departments || [];
      setDepartmentsList(Data.map((d) => ({
        value: d.id,
        label: d.name,
        initials: d.name.split(" ").map((w) => w[0]).join("").toUpperCase().slice(0, 2),
      })));
    });
  };

  const getCompanyUsers = () => {
    UserService.getHolidaysActiveUsers(compid).then((res) => {
      const Data = res.data.users || [];
      setUsersList(Data.map((u) => ({
        value: u.id,
        label: `${u.first_name} ${u.last_name}`,
        initials: `${u.first_name?.[0] || ""}${u.last_name?.[0] || ""}`.toUpperCase(),
        department: u.department,
      })));
    });
  };

  const getFilteredUsers = (selectedDepts) => {
    if (!selectedDepts || selectedDepts.length === 0) return usersList;
    const deptIds = selectedDepts.map((d) => String(d.value));
    return usersList.filter((u) => {
      let uDept = u.department;
      if (Array.isArray(uDept)) uDept = uDept[0]?.id || uDept[0]?._id || uDept[0];
      else if (uDept !== null && typeof uDept === "object") uDept = uDept.id || uDept._id;
      if (uDept === null || uDept === undefined) return false;
      return deptIds.includes(String(uDept));
    });
  };

  const handelPageChange = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const getAllHolidays = () => {
    setLoading(true);
    HolidayService.getHolidays(compid)
      .then((res) => { setHolidaysList(res.data.holidays); })
      .catch((err) => { console.error("Error fetching holidays:", err); })
      .finally(() => { setLoading(false); });
  };

  const createHolidays = (e) => {
    e.preventDefault();
    if (!name) { setError("Holiday name is required!"); return; }

    const Body = {
      company_id: compid,
      name,
      date: moment(date).format("DD/MM/YYYY"),
      enddate: moment(enddate).format("DD/MM/YYYY"),
      type,
      departments: selectedDepartments.map((d) => d.value),
      users: selectedUsers.map((u) => u.value),
    };

    HolidayService.createHolidays(Body)
      .then((res) => {
        if (res?.Good === true || res?.status === 200) {
          message.success("Holiday created successfully!");
          document.getElementById("createmodalclose").click();
          clearCreateState();
          getAllHolidays();
        } else {
          message.error("Failed to create holiday!");
        }
      })
      .catch((err) => {
        console.error("Error creating holiday:", err);
        message.error("Something went wrong while creating holiday!");
      });
  };

  const handelDelete = (e, item) => {
    e.preventDefault();
    setDeleteModal({ visible: true, item });
  };

  const confirmDelete = async () => {
    const item = deleteModal.item;
    setHolidaysList((prev) => prev.filter((el) => el.id !== item.id));
    setDeleteModal({ visible: false, item: null });
    try {
      const res = await HolidayService.deleteHoliday(item.id);
      if (res?.Good === true || res?.status === 200) {
        message.success("Holiday deleted successfully!");
      } else {
        message.error("Failed to delete holiday!");
      }
      getAllHolidays();
    } catch (err) {
      console.error("Error deleting holiday:", err);
      message.error("Something went wrong while deleting!");
      getAllHolidays();
    }
  };

  const handelEdit = (e, item) => {
    setEditName(item.name);
    setEditDate(item.date ? moment(item.date, "DD/MM/YYYY") : null);
    setEditEndDate(item.enddate ? moment(item.enddate, "DD/MM/YYYY") : null);
    setEditType(item.type);
    setEditId(item.id);
    const deptOpts = item.departments
      ? item.departments.map((id) => departmentsList.find((d) => Number(d.value) === Number(id))).filter(Boolean)
      : [];
    setEditSelectedDepartments(deptOpts);
    const userOpts = item.users
      ? item.users.map((id) => usersList.find((u) => Number(u.value) === Number(id))).filter(Boolean)
      : [];
    setEditSelectedUsers(userOpts);
  };

  const handelUpdate = (e) => {
    e.preventDefault();
    if (!editName || editName.trim() === "") { setError("Holiday name is required!"); return; }
    if (!editDate || !editEndDate || !editType) {
      message.error("Please fill all required fields!");
      return;
    }

    const Body = {
      name: editName,
      date: moment(editDate).format("DD/MM/YYYY"),
      enddate: moment(editEndDate).format("DD/MM/YYYY"),
      type: editType,
      departments: editSelectedDepartments.map((d) => d.value),
      users: editSelectedUsers.map((u) => u.value),
    };

    HolidayService.updateHolidays(editId, Body)
      .then((res) => {
        if (res?.Good === true || res?.status === 200) {
          message.success("Holiday updated successfully!");
          document.getElementById("holidyacloseEdit").click();
          clearEditState();
          getAllHolidays();
        } else {
          message.error("Failed to update holiday!");
        }
      })
      .catch((err) => {
        console.error("Error updating holiday:", err);
        message.error("Something went wrong while updating!");
      });
  };

  const clearCreateState = () => {
    setName("");
    setDate(datee);
    setEndDate(dateee);
    setType("Full Day");
    setError("");
    setSelectedDepartments([]);
    setSelectedUsers([]);
  };

  const clearEditState = () => {
    setEditName("");
    setEditDate(null);
    setEditEndDate(null);
    setEditType("");
    setEditId(null);
    setError("");
    setEditSelectedDepartments([]);
    setEditSelectedUsers([]);
  };

  const PaginatedData = paginate(holidaysList, currentPage, pageSize);

  return (
    <>
      <Helmet>
        <title>Company Holidays - Planit</title>
      </Helmet>

      {/* Delete Confirmation Modal */}
      {deleteModal.visible && (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }} onClick={() => setDeleteModal({ visible: false, item: null })}>
          <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
              <div className="modal-header border-0 pb-1">
                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Delete Holiday</h5>
                <button type="button" className="btn-close" onClick={() => setDeleteModal({ visible: false, item: null })} />
              </div>
              <div className="modal-body pt-2 pb-2">
                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>
                  Are you sure you want to delete <strong>{deleteModal.item?.name}</strong>?
                </p>
                <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                  <i className="uil uil-exclamation-triangle me-1" />
                  This action cannot be undone.
                </p>
              </div>
              <div className="modal-footer border-0 pt-1">
                <button
                  type="button"
                  className="btn btn-danger waves-effect waves-light"
                  style={{ borderRadius: "5px", fontSize: "13px" }}
                  onClick={confirmDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <div className="d-flex align-items-end justify-content-end" style={{ padding: "0 0 12px 0" }}>
                  <div className="d-flex flex-column align-items-end" style={{ gap: "6px" }}>
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                      </li>
                      <li className="breadcrumb-item active">Company Holidays</li>
                    </ol>
                    {userPermissions.indexOf("holiday-create") !== -1 ? (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        style={{ borderRadius: "5px" }}
                        data-bs-toggle="modal"
                        data-bs-target="#createHolidaysModal"
                      >
                        Create Holiday
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        disabled
                        style={{ opacity: 0.6, cursor: "not-allowed", borderRadius: "5px" }}
                      >
                        Create Holiday
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                  <div className="card-body p-0">
                    <div className="table-responsive listing-table-wrapper">
                      <table className="table mb-0 custom-table listing-table">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th>Sr#</th>
                            <th>Holiday Name</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Type</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <TableSkeleton cols={7} rows={6} />
                          ) : PaginatedData && PaginatedData.length > 0 ? (
                            PaginatedData.map((item, index) => (
                              <tr key={item.id}>
                                <td>{(currentPage - 1) * pageSize + index + 1}</td>
                                <td>{item.name}</td>
                                <td>
                                  <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                    <i className="uil uil-calendar-alt" style={{ color: "#0DDFAB", fontSize: "16px", flexShrink: 0 }} />
                                    {item.date ? moment(item.date, "DD/MM/YYYY").format("D, MMMM YYYY") : "—"}
                                  </span>
                                </td>
                                <td>
                                  <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                    <i className="uil uil-calendar-alt" style={{ color: "#0DDFAB", fontSize: "16px", flexShrink: 0 }} />
                                    {item.enddate ? moment(item.enddate, "DD/MM/YYYY").format("D, MMMM YYYY") : "—"}
                                  </span>
                                </td>
                                <td>{item.type}</td>
                                <td>
                                  {userPermissions.indexOf("holiday-edit") !== -1 ? (
                                    <StatusBadge item={item} api={HolidayService.statusUpdate} />
                                  ) : (
                                    item.status === "1"
                                      ? <span className="badge bg-success text-white">Active</span>
                                      : <span className="badge bg-danger text-white">Inactive</span>
                                  )}
                                </td>
                                <td className="tableset">
                                  {userPermissions.indexOf("holiday-edit") !== -1 ? (
                                    <Link
                                      to="#"
                                      className="cursor-pointer iconscolor"
                                      onClick={(e) => handelEdit(e, item)}
                                      data-bs-toggle="modal"
                                      data-bs-target="#editHolidaysModal"
                                    >
                                      <Tooltip title="Edit Holiday">
                                        <i className="uil-pen iconscolor" />
                                      </Tooltip>
                                    </Link>
                                  ) : (
                                    <span className="uil-pen iconscolor text-muted" style={{ cursor: "not-allowed", opacity: 0.5 }} />
                                  )}
                                  {userPermissions.indexOf("holiday-delete") !== -1 ? (
                                    <Link
                                      to="#"
                                      className="cursor-pointer iconscolor"
                                      onClick={(e) => handelDelete(e, item)}
                                    >
                                      <Tooltip title="Delete Holiday">
                                        <i className="uil-trash iconscolor" />
                                      </Tooltip>
                                    </Link>
                                  ) : (
                                    <span className="uil-trash iconscolor text-muted" style={{ cursor: "not-allowed", opacity: 0.5 }} />
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center">
                                No holidays found. Click 'Create Holiday' to add one.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>

                      {holidaysList.length > pageSize && (
                        <div className="d-flex justify-content-center mt-4">
                          <Pagination
                            itemCount={holidaysList.length}
                            currentPage={currentPage}
                            pageSize={pageSize}
                            onPageChange={handelPageChange}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Create Modal */}
        <div
          id="createHolidaysModal"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
              <div className="modal-header border-0 pb-1">
                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Create Holiday</h5>
                <button
                  type="button"
                  className="btn-close"
                  id="createmodalclose"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={clearCreateState}
                />
              </div>
              <form onSubmit={createHolidays}>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap mb-3">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="createHolidayName"
                      placeholder=" "
                      value={name}
                      onChange={(e) => { setName(e.target.value); if (e.target.value.trim()) setError(""); }}
                    />
                    <label htmlFor="createHolidayName">Holiday Name*</label>
                  </div>
                  {error && <small className="text-danger d-block mb-2">{error}</small>}

                  <div className="row mb-3">
                    <div className="col-6">
                      <div className={`float-select-wrap ${date ? "has-value" : ""}`}>
                        <label>Start Date</label>
                        <DatePicker
                          placeholder=""
                          allowClear={false}
                          value={moment(date)}
                          onChange={(val) => setDate(val)}
                          format="DD-MM-YYYY"
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className={`float-select-wrap ${enddate ? "has-value" : ""}`}>
                        <label>End Date</label>
                        <DatePicker
                          placeholder=""
                          allowClear={false}
                          value={moment(enddate)}
                          onChange={(val) => setEndDate(val)}
                          format="DD-MM-YYYY"
                        />
                      </div>
                    </div>
                  </div>

                  <div className={`float-select-wrap ${type ? "has-value" : ""} mb-3`}>
                    <label>Type</label>
                    <Select placeholder="" value={type} onChange={setType}>
                      <Option value="Full Day">Full Day</Option>
                      <Option value="Half Day">Half Day</Option>
                    </Select>
                  </div>

                  <div className="mb-3">
                    <UserMultiSelect
                      options={departmentsList}
                      value={selectedDepartments}
                      onChange={setSelectedDepartments}
                      label="Departments"
                      placeholder="Selected departments will appear here..."
                      searchPlaceholder="Search departments..."
                      showAvatar={false}
                      allowSelectAll
                    />
                  </div>

                  <div className="mb-1">
                    <UserMultiSelect
                      options={getFilteredUsers(selectedDepartments)}
                      value={selectedUsers}
                      onChange={setSelectedUsers}
                      label="Users"
                      placeholder="Selected users will appear here..."
                      allowSelectAll
                    />
                  </div>
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    type="submit"
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    + Create Holiday
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Edit Modal */}
        <div
          id="editHolidaysModal"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
              <div className="modal-header border-0 pb-1">
                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Edit Holiday</h5>
                <button
                  type="button"
                  className="btn-close"
                  id="holidyacloseEdit"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={clearEditState}
                />
              </div>
              <form onSubmit={handelUpdate}>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap mb-3">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="editHolidayName"
                      placeholder=" "
                      value={editName || ""}
                      onChange={(e) => { setEditName(e.target.value); if (e.target.value.trim()) setError(""); }}
                    />
                    <label htmlFor="editHolidayName">Holiday Name*</label>
                  </div>
                  {error && <small className="text-danger d-block mb-2">{error}</small>}

                  <div className="row mb-3">
                    <div className="col-6">
                      <div className={`float-select-wrap ${editDate ? "has-value" : ""}`}>
                        <label>Start Date</label>
                        <DatePicker
                          placeholder=""
                          allowClear={false}
                          value={editDate ? moment(editDate) : null}
                          onChange={(val) => setEditDate(val)}
                          format="DD-MM-YYYY"
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className={`float-select-wrap ${editEndDate ? "has-value" : ""}`}>
                        <label>End Date</label>
                        <DatePicker
                          placeholder=""
                          allowClear={false}
                          value={editEndDate ? moment(editEndDate) : null}
                          onChange={(val) => setEditEndDate(val)}
                          format="DD-MM-YYYY"
                        />
                      </div>
                    </div>
                  </div>

                  <div className={`float-select-wrap ${editType ? "has-value" : ""} mb-3`}>
                    <label>Type</label>
                    <Select placeholder="" value={editType} onChange={setEditType}>
                      <Option value="Full Day">Full Day</Option>
                      <Option value="Half Day">Half Day</Option>
                    </Select>
                  </div>

                  <div className="mb-3">
                    <UserMultiSelect
                      options={departmentsList}
                      value={editSelectedDepartments}
                      onChange={setEditSelectedDepartments}
                      label="Departments"
                      placeholder="Selected departments will appear here..."
                    />
                  </div>

                  <div className="mb-1">
                    <UserMultiSelect
                      options={getFilteredUsers(editSelectedDepartments)}
                      value={editSelectedUsers}
                      onChange={setEditSelectedUsers}
                      label="Users"
                      placeholder="Selected users will appear here..."
                      allowSelectAll
                    />
                  </div>
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    type="submit"
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Holidays;
